// src/Pages/Login/LoginSuccess.jsx

import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginWithToken } from '../../store/slices/authSlice';
import { signInWithBackendToken } from '../../firebase'; // Firebase 로그인
import './LoginSuccess.css';

const LoginSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [processing, setProcessing] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const accessToken = params.get('token'); // 'token'으로 변경 (기존 'code')
    // const provider = params.get('provider'); // provider 정보는 현재 여기서 직접 사용 안 함
    
    if (!accessToken) {
      setError('Invalid login parameters: No access token found.');
      setProcessing(false);
      navigate('/login', { replace: true, state: { error: 'Login failed: Missing token.' } });
      return;
    }

    async function processLogin() {
      try {
    
        // 1) 백엔드에서 이미 user 정보를 access_token과 함께 보내주지만,
        //    loginWithToken은 user 정보를 다시 가져오거나, 전달받은 user 정보를 사용할 수 있도록 설계됨.
        //    여기서는 access_token만으로 Redux 상태를 업데이트하고, Firebase 로그인을 진행.
        //    loginWithToken이 내부적으로 /api/auth/user를 호출하여 사용자 정보를 가져올 것임.
        const { user, token: confirmedAccessToken, refreshToken: confirmedRefreshToken } = await dispatch(loginWithToken({ token: accessToken })).unwrap();

        // 2) Firebase sign-in (using the confirmed access token from loginWithToken response)
        // signInWithBackendToken는 FastAPI 토큰을 받아 Firebase 커스텀 토큰으로 교환 후 로그인
        if (confirmedAccessToken && user) {
          await signInWithBackendToken(confirmedAccessToken, user.name);
  
        } else {
          throw new Error('Failed to get confirmed token or user from loginWithToken');
        }

        // 3) Redirect home
        setProcessing(false);
        navigate('/home', { replace: true });

      } catch (err) {
        console.error('LoginSuccess error:', err);
        setError(err.message || 'Login processing failed. Please try again.');
        setProcessing(false);
        navigate('/login', { 
          replace: true,
          state: { error: err.message || 'Login failed after callback. Please try again.' }
        });
      }
    }

    processLogin();
  }, [location, dispatch, navigate]);

  if (error) {
    return <div className="error-message">Login Error: {error}</div>;
  }

  return (
    <div className="loading-message">
      {processing ? (
        <div className="loading-spinner-container">
          <img
            src="/How2Play_mainLogo128.png"
            alt="Loading"
            className="logo-spin"
          />
          <p>Finalizing your login...</p>
        </div>
      ) : (
        'Redirecting...'
      )}
    </div>
  );
};

export default LoginSuccess;
